import React from 'react'
import { getConfigProperty } from '@shared/pipes/config'
import { isClient } from '@shared/utils/is-client'
import Link from 'next/link'
import { replaceDynamicVars } from 'regions/utils/replacer'

import { useRegions } from '../../../regions/provider'

import { Props } from './model'

const BASE_URL = getConfigProperty('HOST')

export const ListItemPageLink = ({ region, path, title, isRegional }: Props) => {
	const { currentCity } = useRegions()

	const city = isRegional ? region || currentCity.key : ''

	const pathname = path.startsWith('/') ? path.slice(1) : path
	const preparedPathName = city ? `${city}/${pathname}` : pathname

	const replacedProps = replaceDynamicVars(currentCity, {
		title,
	})

	return (
		<div>
			<Link href={`${BASE_URL}/${preparedPathName}`} className='main-link'>
				{replacedProps.title}
			</Link>
		</div>
	)
}
